export function mediaTransition(node, breakpoints = []) {
  for (let { query, transition, options } of breakpoints) {
    if (window.matchMedia(query).matches) {
      return transition(node, options);
    }
  }
  return () => {};
}

export function mediaAnimation(node, fromTo, breakpoints = []) {
  for (let { query, animation, options } of breakpoints) {
    if (window.matchMedia(query).matches) {
      return animation(node, fromTo, options);
    }
  }
  return () => {};
}
